import * as React from 'react';
import * as Styles from './LoaderSpinner.scss';

const LoaderSpinner = () => <span className={Styles.wrapper}><span className={Styles.spinner} /></span>;

export default LoaderSpinner;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/LoaderSpinner/LoaderSpinner.tsx